import React, { Component } from 'react'
import update from 'immutability-helper'
import PropTypes from 'prop-types'

import classnames from 'classnames'
import { DragDropContext, Droppable } from 'react-beautiful-dnd'

import { reorder, getMonitorValue } from '../../../functions'

import TableInputItem from './table-input-item'
import TableGroup from './table-group'
import TableItem from './table-item'

class Table extends Component {
  constructor(props) {
    super(props)

    this.state = {
      items: undefined,
      itemTypes: [
        {
          id: '1',
          class: 'monitor',
          type: 'wedge-monitor',
          title: 'Wedge monitor'
        },
        {
          id: '2',
          class: 'monitor',
          type: 'in-ear-monitor',
          title: 'In-Ear monitor'
        },
        {
          id: '3',
          class: 'monitor',
          type: 'in-ear-monitor-stereo',
          title: 'In-Ear monitor — stereo'
        }
      ],
      inputItems: undefined,
      paging: {
        stickyColumn: true,
        hideFirstColumn: false,
        offset: 0,
        size: 3
      }
    }

    this.component = React.createRef()
  }

  componentWillMount() {
    const { items, inputItems } = this.props

    this.setState({items, inputItems})
  }

  componentDidMount() {
    this.calculateTableSize()
  }

  calculateTableSize() {
    const { offsetWidth } = this.component.current
    const channelWidth = 95
    const maxWidth = 180

    const size = Math.floor((offsetWidth - channelWidth) / maxWidth)
    this.setState({
      paging: update(this.state.paging, {
        size: {$set: size}
      })
    })
  }

  componentWillReceiveProps(nextProps) {
    const { items, inputItems } = nextProps

    if (items !== this.props.items) this.setState({items})
    if (inputItems !== this.props.inputItems) this.setState({inputItems})
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { fullView, items, inputItems } = nextProps

    if (fullView !== this.props.fullView) return true
    if (items !== this.props.items) return true
    if (inputItems !== this.props.inputItems) return true
    if (nextState !== this.state) return true
    return false
  }

  componentDidUpdate(prevProps, prevState) {
    const { fullView } = prevProps

    if (fullView !== this.props.fullView) this.calculateTableSize()
  }

  reorderList = (result) => {
    if (!result.destination) return null

    if (result.type === 'item') {
      const items = reorder(
        this.state.items,
        result.source.index,
        result.destination.index
      )

      this.setState({items}, () => this.props.moveRiderItem({
        id: result.draggableId,
        position: result.destination.index+1
      }))
    } else
    if (result.type === 'input-item') {
      const inputItems = reorder(
        this.state.inputItems,
        result.source.index,
        result.destination.index
      )

      this.setState({inputItems}, () => this.props.moveRiderItem({
        id: result.draggableId,
        position: result.destination.index+1
      }))
    }
  }

  paginate(paging, operator) {
    this.setState({
      paging: update(paging, {
        offset: {
          $set: !isNaN(operator)
          ? operator
          : operator === 'next'
            ? paging.offset+1
            : paging.offset-1
        }
      })
    })
  }

  render() {
    const { view, members } = this.props
    const { items, itemTypes, inputItems, paging } = this.state

    if (!items) return null

    let itemIndex = undefined
    let itemGroup = false

    let itemsLength = 0
    items.forEach(item => itemsLength = item.class === 'monitor-group' ? itemsLength+2 : itemsLength+1)

    const channelsClassName = classnames({
      'table-item': true,
      'table-item--channels': true,
      'table-item--instruments': inputItems.length > 0
    })

    return (
      <div ref={this.component} className="table">
        <DragDropContext onDragEnd={this.reorderList}>
          <div className="table-items">
            {
              paging.offset > 0
              ? <div className="table--fixed-wrapper">
                  <div className="table--previous-button" style={{left: `${100/paging.size}%`}} onClick={() => this.paginate(paging, 'previous')}>
                    <div className="oval-button oval-button--previous" />
                  </div>
                </div>
              : null
            }

            {
              itemsLength > ((paging.offset-1)+paging.size)
              ? <div className="table--next-button" onClick={() => this.paginate(paging, 'next')}>
                  <div className="oval-button oval-button--next" />
                </div>
              : null
            }

            <Droppable droppableId="table-items" isDropDisabled={!view.editable} direction="horizontal" type="item">
              {(provided, snapshot) => (
                <div className="table-items--droppable"
                  ref={provided.innerRef} >
                  {
                    paging.stickyColumn
                    ? <div className={channelsClassName} style={{minWidth: `${100/paging.size}%`, maxWidth: `${100/paging.size}%`}}>
                        <div className="table-item-head">
                          <div className="table-item-head--output">
                            Output channels
                          </div>

                          {
                            inputItems.length > 0
                            ? <div className="table-item-head--input">
                                Instruments
                              </div>
                            : null
                          }
                        </div>

                        <Droppable droppableId="table-input-items" isDropDisabled={!view.editable} type="input-item">
                          {(provided, snapshot) => (
                            <div className="table-items--droppable"
                              ref={provided.innerRef} >
                              <div className="table-item-body table-item-body--input">
                                {
                                  inputItems.length > 0
                                  ? inputItems.map((item, index) => (
                                      <TableInputItem key={index}
                                        view={view}
                                        item={item}
                                        removeRiderItem={this.props.removeRiderItem}
                                        createRiderItem={this.props.createRiderItem}
                                        editRiderItem={this.props.editRiderItem}
                                        deleteRiderItem={this.props.deleteRiderItem} />
                                    ))
                                  : null
                                }

                                <div className="title link" onClick={() => {
                                  this.props.addRiderItem({
                                    id: null,
                                    group: 'input',
                                    class: 'non-instrument',
                                    type: 'custom',
                                    title: '',
                                    position: inputItems.length+1,
                                    indexes: [
                                      inputItems.length
                                    ]
                                  })
                                }}>Add new non-instrument</div>
                              </div>
                            </div>
                          )}
                        </Droppable>
                      </div>
                    : null
                  }

                  {
                    items.length > 0
                    ? items.map((item, index) => {
                        itemIndex = itemIndex === undefined ? 0 : itemIndex+1

                        if (itemGroup) {
                          itemIndex += 1
                          itemGroup = false
                        }

                        if (item.class.includes('monitor')) {
                          if (item.class === 'monitor-group') itemGroup = true

                          const value = getMonitorValue(item)

                          return item.class === 'monitor-group'
                          ? <TableGroup key={item.id || index}
                              view={view}
                              value={value}
                              item={item}
                              itemIndex={itemIndex}
                              itemTypes={itemTypes}
                              removeRiderItem={(item) => {
                                this.paginate(paging, 'previous')
                                this.props.removeRiderItem(item)
                              }}
                              createRiderItem={(item) => this.props.createRiderItem({...item, group: 'output'})}
                              editRiderItem={this.props.editRiderItem}
                              deleteRiderItem={this.props.deleteRiderItem}
                              deleteRiderItemGroup={this.props.deleteRiderItemGroup}
                              members={members}
                              paging={paging} />
                          : <TableItem key={item.id || index}
                              view={view}
                              value={value}
                              item={item}
                              itemIndex={itemIndex}
                              itemTypes={itemTypes}
                              removeRiderItem={(item) => {
                                this.paginate(paging, 'previous')
                                this.props.removeRiderItem(item)
                              }}
                              createRiderItem={(item) => this.props.createRiderItem({...item, group: 'output'})}
                              createRiderItems={this.props.createRiderItems}
                              cloneRiderItem={this.props.cloneRiderItem}
                              editRiderItem={this.props.editRiderItem}
                              deleteRiderItem={this.props.deleteRiderItem}
                              members={members}
                              paging={paging} />
                        } else {
                          return null
                        }
                      })
                    : <div className="table-item table-item--add">
                        <div className="table-item-head">
                          Start by adding your <a onClick={() => {
                            this.paginate(paging, itemsLength-paging.size+2)
                            this.props.addRiderItem({
                              id: null,
                              group: 'output',
                              class: 'monitor', // monitor-group
                              type: 'monitor',
                              title: '',
                              position: items.length+1,
                              indexes: [
                                items.length
                              ]
                            })
                          }}>first output channel</a>.
                        </div>
                      </div>
                  }
                </div>
              )}
            </Droppable>

            {
              view.editable
              ? <div className="table--add-column-button" onClick={() => {
                  this.paginate(paging, itemsLength-paging.size+2)
                  this.props.addRiderItem({
                    id: null,
                    group: 'output',
                    class: 'monitor', // monitor-group
                    type: 'monitor',
                    title: '',
                    position: items.length+1,
                    indexes: [
                      items.length
                    ]
                  })
                }}>
                  <div className="oval-button oval-button--add" />
                </div>
              : null
            }
          </div>
        </DragDropContext>
      </div>
    )
  }
}

Table.propTypes = {
  view: PropTypes.object,
  fullView: PropTypes.bool,
  group: PropTypes.string,
  items: PropTypes.array,
  inputItems: PropTypes.array,
  addRiderItem: PropTypes.func,
  removeRiderItem: PropTypes.func,
  createRiderItem: PropTypes.func,
  createRiderItems: PropTypes.func,
  cloneRiderItem: PropTypes.func,
  editRiderItem: PropTypes.func,
  moveRiderItem: PropTypes.func,
  deleteRiderItem: PropTypes.func,
  deleteRiderItemGroup: PropTypes.func,
  members: PropTypes.array,
  createStageElement: PropTypes.func,
  getSearchResults: PropTypes.func
}

Table.defaultProps = {
  view: {},
  fullView: false,
  group: '',
  items: [],
  inputItems: [],
  addRiderItem: function() {},
  removeRiderItem: function() {},
  createRiderItem: function() {},
  createRiderItems: function() {},
  cloneRiderItem: function() {},
  editRiderItem: function() {},
  moveRiderItem: function() {},
  deleteRiderItem: function() {},
  deleteRiderItemGroup: function() {},
  members: [],
  createStageElement: function() {},
  getSearchResults: function() {}
}

export default Table



// WEBPACK FOOTER //
// ./src/components/rider/rider-output/output-table/table.js